'use client';

import { SessionProvider } from "next-auth/react"

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  return <SessionProvider data-component-id="src/components/providers/AuthProvider.tsx:6:9" data-component-path="src/components/providers/AuthProvider.tsx" data-component-line="6" data-component-end-line="6" data-component-file="AuthProvider.tsx" data-component-name="SessionProvider" data-component-content="%7B%22elementName%22%3A%22SessionProvider%22%7D">{children}</SessionProvider>
}
